const sharedSettings = {
  user: { editable: true, type: 'habit-user-select', rules: [{ required: true }] },

  parent_area: { editable: true, type: 'hm-userarea-select', rules: [{ required: true }] },
  system_category_name: { editable: true, type: 'hm-category-select', rules: [{ required: false }] },

  custom_category_name: { editable: true, type: 'input', rules: [{ required: false }] },
  description: { editable: true, type: 'textarea', rules: [{ required: false }] },

  date: { editable: true, type: 'datetime', rules: [{ type: 'object' as const }] },

  // area_name: { hidden: true },
  user_email: { hidden: true },

  created_at: { hidden: true },
  updated_at: { hidden: true },
}

export const settings = {
  id: { label: "ID" },
  ...sharedSettings
};

export const initialSettings = {
  id: { hidden: true },
  ...sharedSettings,
}

export const initialValues = {
  system_area_name: null,
  user: null
};
